import { css } from '@emotion/core';
import MediaQueries from '../../../../styles/Grid/MediaQueries';
import { colorsPalette } from '../../../../styles/colors';
import { typography } from '../../../../styles/typography';
import { ANIMATION_LENGTH, BEZIER_CURVES } from '../../../../utils/animations';

export const containerMarginCss = css({
  margin: '32px 0 40px',
  [MediaQueries.md]: {
    margin: '40px 0 60px -10px',
  },
  [MediaQueries.lgAndUp]: {
    margin: '40px 0 0 -60px',
  },
  [MediaQueries.xl]: {
    marginLeft: -65,
  },
});

export const galleryWrapperCss = css({
  [MediaQueries.smAndUp]: {
    width: '100%',
    '.image-0': {
      height: 197,
      width: 351,
    },
    '.image-1': {
      height: 197,
      width: 142,
    },
    '.image-2': {
      height: 197,
      width: 351,
    },
  },
  [MediaQueries.md]: {
    '.image-0': {
      height: 308,
      width: 548,
    },
    '.image-1': {
      height: 308,
      width: 217,
    },
    '.image-2': {
      height: 308,
      width: 556,
    },
  },
  [MediaQueries.lgAndUp]: {
    maxWidth: 800,
    '.image-0': {
      height: 325,
      width: 584,
    },
    '.image-1': {
      height: 246,
      width: 180,
      margin: '72px 32px 0 20px',
    },
    '.image-2': {
      height: 194,
      width: 352,
      marginTop: 39,
    },
  },
  [MediaQueries.xl]: {
    '.image-0': {
      height: 390,
      width: 702,
    },
    '.image-1': {
      height: 296,
      width: 217,
      margin: '59px 32px 0 49px',
    },
    '.image-2': {
      height: 222,
      width: 404,
      marginTop: 35,
    },
  },
});

export const gallerySliderCss = css({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  overflowY: 'hidden',
  maxWidth: '100vw',
  [MediaQueries.lgAndUp]: {
    flexWrap: 'wrap',
    overflow: 'visible',
    maxWidth: '100%',
  },
});

export const viewMoreWrapperCss = css({
  marginTop: 16,
});

export const viewMoreTextCss = css(typography.effra12Link, {
  lineHeight: '20px',
});

export const closeButtonCss = css({
  right: 40,
  top: 32,
  [MediaQueries.mdAndUp]: {
    right: 40,
    top: 32,
  },
});

export const pictureCss = css({
  display: 'block',
  marginRight: 12,
  [MediaQueries.mdAndUp]: {
    marginRight: 16,
  },
  [MediaQueries.lgAndUp]: {
    marginRight: 0,
    overflow: 'hidden',
  },
});

export const imageCss = css({
  cursor:
    'url(/-/media/regus/images/ui/cursor-image-hover.ashx), url(/-/media/regus/images/ui/cursor-image-hover-cur.cur), pointer',
  height: '100%',
  transition: `transform ${ANIMATION_LENGTH._700MS} ${BEZIER_CURVES.FLUID}`,
  transform: 'scale3d(1.06, 1.06, 1)',
  '&:hover': {
    transform: 'scale3d(1, 1, 1)',
  },
  width: '100%',
});

export const buttonResetCss = css({
  backgroundColor: colorsPalette.transparent,
  border: 0,
  padding: 0,
});
